const loading = state => state.loading;
const docPreview = state => state.docPreview;
const visiblePreviewModal = state => state.visiblePreviewModal;
// const validate_question = state => state.validate_question;
const listComment = state => state.listComment;
const commentDetail = state => state.commentDetail;
const paramsSearchComments = state => state.paramsSearchComments;
const pagingComment = state => state.pagingComment;
const paramsSearchCommentDetail = state => state.paramsSearchCommentDetail;
const payloadCreateComment = state => state.payloadCreateComment;
const draw_shape_data = state => state.draw_shape_data;
const toggle_draw = state => state.toggle_draw;
const actionCheckQuestion = state => state.actionCheckQuestion;
const getCountNotifiNotRed = state => state.getCountNotifiNotRed;
const getDataDetailNotifi = state => state.getDataDetailNotifi;
const getPramDisplay = state => state.getPramDisplay;
const isShowModalError = state => state.isShowModalError;
const isShowModalHelp = state => state.isShowModalHelp;

const setListHelp = state => state.setListHelp;
const setIdDetailHelp = state => state.setIdDetailHelp;
const getHelpDetail = state => state.getHelpDetail;
const getHelpVideo = state => state.getHelpVideo;
const setRouterHelp = state => state.setRouterHelp;
const getShowVideoHelp = state => state.getShowVideoHelp;
const setBookIdForError = state => state.setBookIdForError;
const setBookIndexId = state => state.setBookIndexId;
const setPageNoBook = state => state.setPageNoBook;
const setBookPageLinkId = state => state.setBookPageLinkId;
const setQuestionId = state => state.setQuestionId;
const setInfoLibrary = state => state.setInfoLibrary;
const setCountView = state => state.setCountView;
const setCheckExcercise = state => state.setCheckExcercise;
const setCheckSlideActiveBook = state => state.setCheckSlideActiveBook;
const imgSlide = state => state.imgSlide;
const isShowModalNotify = state => state.isShowModalNotify;
const getDataModalNoti = state => state.getDataModalNoti;
const getInfoExcercise = state => state.getInfoExcercise;

export default {
    loading,
    docPreview,
    visiblePreviewModal,
    // validate_question,
    listComment,
    commentDetail,
    paramsSearchComments,
    pagingComment,
    paramsSearchCommentDetail,
    draw_shape_data,
    actionCheckQuestion,
    toggle_draw,
    getCountNotifiNotRed,
    getDataDetailNotifi,
    getPramDisplay,

    isShowModalError,
    isShowModalHelp,
    setListHelp,
    setIdDetailHelp,
    getHelpDetail,
    getHelpVideo,
    setRouterHelp,
    getShowVideoHelp,
    setBookIdForError,
    setBookIndexId,
    setPageNoBook,
    setBookPageLinkId,
    setQuestionId,
    setInfoLibrary,
    setCountView,
    setCheckExcercise,
    setCheckSlideActiveBook,
    imgSlide,
    isShowModalNotify,
    getDataModalNoti,
    getInfoExcercise,
};